export default __webpack_public_path__ + "static/media/publication.070697f0.jpeg";